import styled from 'styled-components';

import { motion } from 'framer-motion';
import { theme } from '../../../theme';

import { TriangleProps, WrapProps } from './types';

const Container = styled.div`
  display: inline-block;
`;

const Triangle = styled.div`
  background-color: ${theme.colors.neutral.ink.dark};
  height: 16px;
  width: 16px;
  position: absolute;
  transform: rotate(45deg);
  z-index: ${theme.layers.tooltip};
`;

const Tip = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.15 },
})<TriangleProps>`
  width: max-content;
  pointer-events: none;
  will-change: opacity, transform;

  &[data-popper-placement^='top-start'] > #veeqo-components-triangle {
    left: 8px;
    bottom: 0px;
  }
  &[data-popper-placement^='top-end'] > #veeqo-components-triangle {
    right: 8px;
    bottom: 0px;
  }

  &[data-popper-placement^='bottom-start'] > #veeqo-components-triangle {
    left: 8px;
    top: -4px;
  }
  &[data-popper-placement^='bottom-end'] > #veeqo-components-triangle {
    right: 8px;
    top: -4px;
  }
`;

const Wrap = styled(Container)<WrapProps>`
  padding: ${theme.sizes.base} ${theme.sizes[5]};
  overflow: hidden;
  z-index: 10;

  min-width: ${({ tipMinWidth }) => tipMinWidth}px;
  max-width: ${({ tipMaxWidth }) => tipMaxWidth}px;

  color: #fff;
  border-radius: ${theme.sizes.sm};
  box-shadow: ${theme.shadows.base};
  background: ${theme.colors.neutral.ink.dark};
`;

export { Container, Tip, Wrap, Triangle };
